const cities = [
    {
        start: {
            lat: 51.768732,
            lng: 19.456991,
        },
        end: {
            lat: 34.0522,
            lng: -118.2437,
        },
    },
    {
        start: {
            lat: 51.768732,
            lng: 19.456991,
        },
        end: { lat: -15.7975, lng: -47.8919 },
    },

    {
        start: {
            lat: 51.768732,
            lng: 19.456991,
        }, // London
        end: { lat: 28.6139, lng: 77.209 },
    },
    {
        start: { lat: 28.6139, lng: 77.209 },
        end: { lat: 43.1332, lng: 131.9113 },
    },
    {
        start: { lat: 28.6139, lng: 77.209 },
        end: { lat: -1.2921, lng: 26.8219 },
    },
    {
        start: { lat: -53.127505, lng: 43.147051 }, // Bialystok
        end: { lat: 51.768732,
            lng: 19.456991, },
    },
    {
        start: { lat: 143.127505, lng: -33.147051 }, // Bialystok
        end: { lat: 51.768732,
            lng: 19.456991, },
    },
]

export default cities